import getWithToken from './base/get-with-token'

const getCustomersTaxonomies = getWithToken(`/customer-taxonomy`)

export default getCustomersTaxonomies